import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class LoginGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const loginPath = '/super-login';
    const path = route.routeConfig.path;

    const administratorId = localStorage.getItem('administratorId');

    if (administratorId === null || administratorId === undefined) {
      this.router.navigate([loginPath]);
      return false;
    } else {
      return true;
    }
  }
}
